import { render, staticRenderFns } from "./CreateSubTask.vue?vue&type=template&id=4a279177&scoped=true&lang=pug"
import script from "./CreateSubTask.vue?vue&type=script&lang=js"
export * from "./CreateSubTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a279177",
  null
  
)

export default component.exports